// Packages
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Models
import useModels from '../../models';

/**
 * AuthGuard - Protects routes by checking if user has a valid session
 * Redirects to login if no authToken exists
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component(s) to render if authenticated
 * @returns {React.ReactNode} - Children if authenticated, Navigate to login otherwise
 */
const AuthGuard = ({ children }) => {
  const location = useLocation();

  // Models
  const { useSelectors } = useModels();
  const { useSelector, useAuthSelectors } = useSelectors();
  const { session } = useAuthSelectors();
  const { authToken } = useSelector(session);

  // If no auth token exists, redirect to login
  if (!authToken) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // User has a valid session, render the protected content
  return <>{children}</>;
};

export default AuthGuard;
